import { render, staticRenderFns } from "./ContestWinnersGroup.vue?vue&type=template&id=5da71780"
import script from "./ContestWinnersGroup.vue?vue&type=script&lang=ts"
export * from "./ContestWinnersGroup.vue?vue&type=script&lang=ts"
import style0 from "./ContestWinnersGroup.vue?vue&type=style&index=0&id=5da71780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports